import React from 'react';

export default function MarketingCapabilities({ recentlyPublished, popularCategories }) {
    return (
        <div id="capabilities">
            <div className="capabilities-section">

                {/* Row 2 */}
                <div className="cap-row reverse reveal">
                    <div>
                        <div className="cap-eyebrow">Source transparency</div>
                        <h3 className="cap-title">Every answer,<br /><em>fully traceable</em></h3>
                        <p className="cap-desc">Research demands rigour. Axon surfaces the exact journal, author, year, and page for every claim — so you can cite, verify, and trust your outputs completely.</p>
                        <ul className="cap-points">
                            <li><span className="cap-check">✓</span>Direct links to source PDFs and abstracts</li>
                            <li><span className="cap-check">✓</span>Auto-generated bibliography in APA / Vancouver</li>
                            <li><span className="cap-check">✓</span>Confidence scoring on each retrieved claim</li>
                        </ul>
                        <a href="#" className="cap-link">See source panel →</a>
                    </div>
                    <div className="cap-visual cap-visual-dark">
                        <div className="cap-visual-eyebrow">Sources — This response</div>
                        <div className="cite-stack">
                            <div className="cite-card">
                                <div className="cite-num">1</div>
                                <div>
                                    <div className="cite-name">McDonald Criteria 2017 — Revised MS Guidelines</div>
                                    <div className="cite-journal">Thompson AJ et al. Lancet Neurol. 2018;17(2):162–173</div>
                                </div>
                            </div>
                            <div className="cite-card">
                                <div className="cite-num">2</div>
                                <div>
                                    <div className="cite-name">MAGNIMS MRI Consensus Recommendations</div>
                                    <div className="cite-journal">Filippi M et al. Nat Rev Neurol. 2016;12:714–722</div>
                                </div>
                            </div>
                            <div className="cite-card">
                                <div className="cite-num">3</div>
                                <div>
                                    <div className="cite-name">AAN MS Clinical Practice Advisory 2022</div>
                                    <div className="cite-journal">Rae-Grant A et al. Neurology. 2022;98:1</div>
                                </div>
                            </div>
                        </div>
                        <div className="cap-visual-export">
                            ✦ Export as Vancouver · APA · BibTeX
                        </div>
                    </div>
                </div>

            </div>
        </div>
    );
}
